import {
  DEFAULT_DOCTOR_IMAGE_FEMALE,
  DEFAULT_DOCTOR_IMAGE_MALE,
} from "@/types/doctor.definition";
import {
  DEFAULT_SECRETARY_IMAGE_FEMALE,
  DEFAULT_SECRETARY_IMAGE_MALE,
} from "@/types/secretary.definition";
import { CivilityEnum, RoleEnum } from "@/types/user.definition";

/**
 * Default avatar for a staff member without a photo, by role and civility.
 * Anyone who is not a secretary gets the doctor image.
 */
export const getDefaultStaffImage = (roleName?: string, civility?: string): string => {
  const isMan = civility === CivilityEnum.MR;
  if (roleName === RoleEnum.SECRETARY) {
    return isMan ? DEFAULT_SECRETARY_IMAGE_MALE : DEFAULT_SECRETARY_IMAGE_FEMALE;
  }
  return isMan ? DEFAULT_DOCTOR_IMAGE_MALE : DEFAULT_DOCTOR_IMAGE_FEMALE;
};
